const progressHandler = require('../utils/progressBar')

export default {
	namespace: 'home',
	beforeEnter(barba) {

	},
	afterEnter(barba) {
		console.log('View: home')

		let donationWidgetEl = barba.next.container.querySelector('.donation-widget')
		if (donationWidgetEl) {
			let bar = progressHandler(donationWidgetEl)
			let progress = donationWidgetEl.dataset.progress || 0
			bar.animate(progress)
		}

	},
	beforeLeave(barba) {

	},
	afterLeave(barba) {

	}
}
